var path = '/app/vehicle-registrations/vehicle-registration.status.html';
var html = "<div class=\"status m-top-0\"\n  data-ng-class=\"getClasses()\">\n  <span data-ng-bind=\"getStatusMessage()\"></span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;